module.exports = __webpack_public_path__ + "assets/img/img-detail-sp.98e5ca9c.jpg";